import React from 'react'

import { useTranslation } from 'react-i18next'
import TitleComponent from '../../../global/Custom/TitleComponent/TitleComponent'
import ContactEditScreen from './ContactEditScreen'

function ContactEditPage() {
  const {t} = useTranslation()

  return (
    <div>
        <TitleComponent title={t('Chỉnh sửa liên hệ')} isExist={false} />
        <ContactEditScreen/>
    </div>
  )
}

export default ContactEditPage
